<div class="layout-row layout-align-start-center"
     (mouseenter)="isShowActions=true"
     (mouseleave)="isShowActions=false">

  <span *ngIf="!branches?.length">---</span>

  <div *ngIf="branches?.length" class="flex layout-row layout-align-start-center" container="body" [ngbTooltip]="tooltipTmpl" openDelay="300" triggers="hover">
    <app-bringoz-state-link [state]="'branch.shipper-accounts'"
                            [params]="{id: branches[0].id}"
                            [text]="branches[0].name"
                            [openInNewTab]="openInNewTab">
    </app-bringoz-state-link>

    <span *ngIf="branches.length > 1" class="br-body-2"> +{{branches.length - 1}}</span>

  </div>

  <bz-button *ngIf="isShowFilterByButton && isShowActions"
             variant="tertiary"
             size="fit"
             [ariaLabel]="'Filter' | translate"
             (clicked)="filterByTypeEvent($event)">
    <bz-icon [icon]="icons.filter"></bz-icon>
  </bz-button>

</div>


<ng-template #tooltipTmpl>
  <div class="flex flex-column">
    <div *ngFor="let branch of branches" class="br-body-2 margin-bottom-5">{{branch.name}}</div>
  </div>
</ng-template>
